import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";

import {
    BVNStatusEnum,
    UserTypeEnum,
    businessCategoryEnum,
    directorRequiredEnum,
    getIDFromEnum,
    pepCompletedStatusEnum,
    smeProfileStatusEnum,
} from "../allEnums";
import { accessLevelList } from "../accessLevelEnum";
import { refreshToken } from "../../redux/actions/accounts.action";

const useOnboardingChecks = () => {
    const dispatch = useDispatch();

    const userToRecheckSubmissions = JSON.parse(Cookies.get("reviewOnboardingDocuments") || null);

    const {
        singleSmeAccount,
        rawData,
        singleSmeAccount: {
            signatory,
            customerCategory,
            businessCategory,
            smeProfileStatus,
            accountOpeningReason,
            directorRequired,
        },
    } = useSelector((state) => state.accountState);

    const { accessLevel } = signatory;
    const { bvnStatus, idStatus, accountNumber, addressVerificationStatus } = singleSmeAccount;

    const isAdmin = accessLevel === getIDFromEnum("Admin", accessLevelList);
    const isFreelancer = businessCategory === getIDFromEnum("Freelancer", businessCategoryEnum);
    const isBusinessName = businessCategory === getIDFromEnum("BusinessName", businessCategoryEnum);
    const isLLC = businessCategory === getIDFromEnum("LimitedLiability", businessCategoryEnum);
    const isBVNSubmitted = bvnStatus === getIDFromEnum("Pending", BVNStatusEnum);
    const isBVNVerified = bvnStatus === getIDFromEnum("Done", BVNStatusEnum);
    const isDocumentSubmitted = idStatus === getIDFromEnum("Pending", BVNStatusEnum);
    const isDocumentVerified = idStatus === getIDFromEnum("Done", BVNStatusEnum);
    const kycDone = Boolean(isBVNVerified && isDocumentVerified);
    const kybDone = Boolean(
        singleSmeAccount?.accountOpeningReason && singleSmeAccount?.monthlyTurnOver,
    );
    const freelancerOnboardingCompleted = Boolean(kycDone && kybDone);
    const pepNotDone =
        rawData?.pepCompletedStatus === getIDFromEnum("NotDone", pepCompletedStatusEnum);
    const isBusinessUser = customerCategory === getIDFromEnum("BUSINESS", UserTypeEnum);
    const isRetailUser = customerCategory === getIDFromEnum("RETAIL", UserTypeEnum);

    const directorNotDone = directorRequired === getIDFromEnum("NotDone", directorRequiredEnum);
    const directorIsRequired =
        directorRequired === getIDFromEnum("IsRequired", directorRequiredEnum);
    const directorIsNotRequired =
        directorRequired === getIDFromEnum("IsNotRequired", directorRequiredEnum);


    const isFullBusiness =
        smeProfileStatus === getIDFromEnum("Active", smeProfileStatusEnum) &&
        businessCategory !== getIDFromEnum("Freelancer", businessCategoryEnum);

    const isFullBusinessNew =
        businessCategory !== getIDFromEnum("Freelancer", businessCategoryEnum);

    const accountPendingActivation =
        (smeProfileStatus === getIDFromEnum("PendingActivation", smeProfileStatusEnum) ||
            smeProfileStatus === getIDFromEnum("UpdateNeeded", smeProfileStatusEnum) ||
            smeProfileStatus === getIDFromEnum("LoggedForApproval", smeProfileStatusEnum)) &&
        !accountNumber;

    const freelancerPendingActivation =
        (addressVerificationStatus === "IN_REVIEW" || addressVerificationStatus === "UNVERIFIED") &&
        !accountNumber;

    const accountInactive =
        accountPendingActivation ||
        smeProfileStatus === getIDFromEnum("Inactive", smeProfileStatusEnum) ||
        smeProfileStatus === getIDFromEnum("Declined", smeProfileStatusEnum) ||
        !accountOpeningReason;

    const refreshTokenFn = async () => {
        const getSessionKudaAppToken = sessionStorage.getItem("kudaAppToken");
        const getkudaAppRefreshToken = Cookies.get("kudaAppRefreshToken");

        const token = {
            RefreshToken: getkudaAppRefreshToken,
        };
        const payload = {
            isTokenExchange: true,
        };
        const result = await dispatch(refreshToken(payload, token));

        if (result.status === true) {
            const AppToken = result.data.accessToken;
            const refreshToken = result.data.refreshToken;
            const expiresIn = result.data.tokenExpiryInMinutes;
            Cookies.set("kudaAppRefreshToken", refreshToken, {
                secure: true,
                path: "/",
            });
            Cookies.set("expiresIn", expiresIn, {
                secure: true,
                path: "/",
            });
            getSessionKudaAppToken
                ? sessionStorage.setItem("kudaAppToken", AppToken)
                : Cookies.set("kudaAppToken", AppToken, {
                      secure: true,
                      path: "/",
                  });
        }
    };

    return {
        isBVNSubmitted,
        isBVNVerified,
        isDocumentSubmitted,
        isDocumentVerified,
        kycDone,
        kybDone,
        isAdmin,
        directorNotDone,
        directorIsRequired,
        directorIsNotRequired,
        isBusinessUser,
        isRetailUser,
        isFreelancer,
        isBusinessName,
        isFullBusiness,
        isFullBusinessNew,
        isLLC,
        pepNotDone,
        freelancerOnboardingCompleted,
        accountPendingActivation,
        accountInactive,
        userToRecheckSubmissions,
        freelancerPendingActivation,
        refreshTokenFn,
    };
};

export default useOnboardingChecks;
